import { useI18N } from "@sundae/react-hooks";
import { TNotice } from "@sundae/ui-toolkit/dist/types/components/molecules/Notice/Notice";
import { FC, memo } from "react";
import { useMigrateLiquidityContext } from "../../Dialogs/MigrateLiquidityDialog/context";
import Warning from "../../Warning";

const MaybeLiquidityPoolMigrationWarning: FC<TNotice> = (noticeProps) => {
  const { t } = useI18N("warnings");
  const {
    derived: { isLoadingV3Pools, isMigrateLiquidityConfigEmpty },
  } = useMigrateLiquidityContext();

  if (!isLoadingV3Pools && isMigrateLiquidityConfigEmpty) {
    return (
      <Warning
        {...noticeProps}
        warning="liquidityPoolMigration"
        title={t("warning.title.liquidityPoolMigration")}
      />
    );
  }

  return null;
};

export default memo(MaybeLiquidityPoolMigrationWarning);
